import { render, staticRenderFns } from "./DateFieldCustom.vue?vue&type=template&id=04b69e46&scoped=true&"
import script from "./DateFieldCustom.vue?vue&type=script&lang=ts&"
export * from "./DateFieldCustom.vue?vue&type=script&lang=ts&"
import style0 from "./DateFieldCustom.vue?vue&type=style&index=0&id=04b69e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b69e46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VSpacer,VTextField})
